__turbopack_context__.v({
  "badge": "NotificationButton-module__pnNnbG__badge",
  "btn": "NotificationButton-module__pnNnbG__btn",
});
